import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loading from "./Utils/Loading";
import CustomThemeProvider from "./Context/CustomThemeProvider";
import LocalRouter from "./Router/LocalRouter";
import { WebsocketProvider } from "./Context/WebSocketContext";
import { DrawerStateContextProvider } from "./Context/DrawerStateContext";
import { TaskContextProvider } from "./Context/TaskContext";
import { RefreshDataContextProvider } from "./Context/RefreshDataContext";
import Login from "./Pages/LoginPage";
import { FilePreviewContextProvider } from "./Context/DataFileContext";
import PageNotFound from "./Components/PageNotFound";
import { Vocabulary } from "./Utils/Vocabulary";
import { localUrlEnum } from "./Utils/UrlEnum";
import { usePwaInstallSilent } from "./usePwaInstall";
import { useEffect } from "react";

export default function App() {
  usePwaInstallSilent();

  // Redirect silently on app load (works anywhere)
  useEffect(() => {
    const path = localStorage.getItem("pwaStartPath");
    if (path && path !== window.location.pathname) {
      window.location.href = path; // full reload to saved path
      localStorage.removeItem("pwaStartPath");
    }
  }, []);

  // Reload the page when auth data changes in another tab to prevent stale role-based access
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "userRoles" || event.key === "access_token") {
        window.location.reload();
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  
  return (
    <CustomThemeProvider>
      <WebsocketProvider>
        <RefreshDataContextProvider>
          <DrawerStateContextProvider>
            <TaskContextProvider>
              <FilePreviewContextProvider>
                <ToastContainer
                  style={{ zIndex: 99999 }}
                  hideProgressBar={true}
                />
                {window.localStorage.getItem("userRoles") ? (
                  <LocalRouter name={"LocalRouter"} />
                ) : (
                  <BrowserRouter>
                    <Routes>
                      <Route
                        path="/*"
                        element={
                          <PageNotFound text={Vocabulary.pageNotFound} />
                        }
                      />
                      <Route
                        path={`${localUrlEnum.login}`}
                        element={<Login />}
                      />
                    </Routes>
                  </BrowserRouter>
                )}
                <Loading />
              </FilePreviewContextProvider>
            </TaskContextProvider>
          </DrawerStateContextProvider>
        </RefreshDataContextProvider>
      </WebsocketProvider>
    </CustomThemeProvider>
  );
}
